import { render, staticRenderFns } from "./Auction.vue?vue&type=template&id=0d355cd7&scoped=true"
import script from "./Auction.vue?vue&type=script&setup=true&lang=js"
export * from "./Auction.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Auction.vue?vue&type=style&index=0&id=0d355cd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d355cd7",
  null
  
)

export default component.exports